
const filterTypes = {
    equal: 'equal',
    notEqual: 'notEqual',
    greaterThan: 'greaterThan',
    greaterOrEqualThan: 'greaterThan',
    lessThan: 'lessThan',
    lessOrEqualThan: 'lessOrEqualThan',
    contains: 'contains'
}

export default filterTypes;



// WEBPACK FOOTER //
// ./src/components/Common/DataTable/dataTableFilterTypes.js